<template>
  <v-app :style="appStyle">
    <link
      v-if="cs.fontName"
      :href="'https://fonts.googleapis.com/css?family=' + cs.fontName + ':100,300,500,700&display=swap'" rel="stylesheet"
    >
    <LeftMenu />
    <RightMenu />
    <snackbar />
    <login v-if="!authenticated" />
    <v-container v-else-if="!modulesLoaded" fill-height pa-0>
      <v-flex xs6 offset-xs3>
        <v-layout elevation-4 wrap mt-12 pa-5>
          ... loading ...
        </v-layout>
      </v-flex>
    </v-container>
    <v-container v-else container--fluid class="pa-0">
      <v-app-bar
        dark
        :color="cs.toolbarBackgrondColor || 'blue-grey lighten-1'"
        fixed
        :src="cs.toolbarBackgroundImage"
        flat
      >
        <v-app-bar-nav-icon @click="showMenu = !showMenu"></v-app-bar-nav-icon>
        <v-toolbar-title v-if="$vuetify.breakpoint.mdAndUp" class="app-bar-tenant-name">{{ $store.state.tenant }}</v-toolbar-title>
        <v-spacer v-if="!$vuetify.breakpoint.smAndDown"></v-spacer>

        <div
          v-if="$vuetify.breakpoint.smAndDown"
          class="mobile-app-bar-module-title"
        >
            {{
              modules && modules[selectedModuleName] && (modules[selectedModuleName]['namePlural_' + language] || modules[selectedModuleName].namePlural_en || selectedModuleName)
            }}
        </div>

        <div
          v-if="adminTopLinks && !$vuetify.breakpoint.smAndDown"
          style="    overflow: hidden;
          white-space: nowrap;"
          @click="showRightMenu = !showRightMenu"
        >
          <v-btn
            v-for="(link, tl_index) in adminTopLinks.filter(link => !link.limitForUserGroups ||
              (link.limitForUserGroups &&
              user.userGroup && user.userGroup.identifier &&
              link.limitForUserGroups.split(',').includes(user.userGroup.identifier))
              )"
            :color="link.color || 'white'"
            dark
            :text="link.iconOnly"
            :icon="link.iconOnly"
            :fab="!link.iconOnly && !$vuetify.breakpoint.lgAndUp"
            :to="'/' + (link.moduleName || '')"
            class="mr-2"
            :small="!link.iconOnly && !$vuetify.breakpoint.lgAndUp"
            @click.stop=""
          >
            <v-icon
              v-if="link.icon"
              :small="!link.iconOnly && !$vuetify.breakpoint.lgAndUp"
              :class="!link.iconOnly && $vuetify.breakpoint.lgAndUp ? 'pr-2' : ''"
            >
              {{ link.icon }}
            </v-icon>
            <template v-if="!link.iconOnly && $vuetify.breakpoint.lgAndUp">
              {{ modules && modules[link.moduleName] && modules[link.moduleName]['namePlural_' + language] }}
            </template>
          </v-btn>
        </div>

        <v-spacer></v-spacer>
        <v-btn
          v-if="$vuetify.breakpoint.smAndDown"
          @click="toggleMainListSearchClose"
          icon
        >
          <v-icon
            small
          >
            fa-search
          </v-icon>
        </v-btn>
        <v-btn
          v-if="!$vuetify.breakpoint.smAndDown"
          icon @click="$store.dispatch('logout')"
        >
          <v-icon>fa-times</v-icon>
        </v-btn>
        <v-btn icon @click="showRightMenu = !showRightMenu">
          <v-icon>fa-ellipsis-v</v-icon>
        </v-btn>
        <!-- v-app-bar-nav-icon @click="showRightMenu = !showRightMenu"></v-app-bar-nav-icon -->
      </v-app-bar>
      <v-row :style="'margin-top: ' + (toolbarHeight + (!$vuetify.breakpoint.smAndDown && !cs.noDesktopGutters ? 10 : 0)) + 'px;'">
        <v-col
          cols="12"
        >
          <router-view />
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import LeftMenu from './components/LeftMenu'
import RightMenu from './components/RightMenu'
import Snackbar from './components/Snackbar'
import Login from './components/login/login'
import sharedComputed from './components/computed'

export default {
  name: 'App',

  components: {
    Login,
    Snackbar,
    LeftMenu,
    RightMenu
  },

  created () {
    this.$store.dispatch('restoreSession')
    window.addEventListener('resize', this.resizeHandler)
  },

  destroyed () {
    window.removeEventListener('resize', this.resizeHandler)
  },

  computed: {
    ...sharedComputed,

    appStyle () {
      let style = {}
      if (this.cs.fontName) {
        style.fontFamily = 'Raleway'
      }
      return style
    }
  },

  methods: {
    toggleMainListSearchClose () {
      const mainListIsOpen = this.$route.path === '/' + this.selectedModuleName
      if (mainListIsOpen) {
        this.searchClosedMobileMainList = !this.searchClosedMobileMainList
      } else {
        this.searchClosedMobileMainList = false
        this.$nextTick(() => {
          this.$router.push('/' + this.selectedModuleName)
        })
      }
    },

    resizeHandler () {
      this.innerHeight = window.innerHeight
      this.innerWidth = window.innerWidth
    }
  }
}
</script>

<style>
.mobile-app-bar-module-title {
  font-size: 20px !important;
  font-weight: 300;
}
.app-bar-tenant-name {
  font-size: 22px !important;
  font-weight: 300;
}
.theme--light.v-data-table.v-data-table--fixed-header thead th {
  background: #eee !important;
}
.theme--light.v-tabs>.v-tabs-bar {
  background-color: inherit !important;
}
.container {
  padding: 0 !important;
}
.row {
  margin-left: 0 !important;
  margin-right: 0 !important;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
.cut-long-text {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.active.desc .v-data-table-header__icon {
  color: green !important;
  font-weight: 700 !important;
}
.active .v-data-table-header__icon {
  color: red !important;
}
</style>
